import { atom, RecoilState } from 'recoil';

export const searchStore: RecoilState<string> = atom<string>({
  key: 'searchStore',
  default: '',
});
